<template>
  <div class="container">
    <!--<div class="explain_grid">
      <h1Letter letter="19"></h1Letter>
      <h1Letter letter="20"></h1Letter>
      <h1Letter letter="15"></h1Letter>
      <h1Letter letter="14"></h1Letter>
      <h1Letter letter="5"></h1Letter>

      <h1Letter :hide="true" letter="1s"></h1Letter>
      <h1Letter :hide="true" letter="1t"></h1Letter>
      <h1Letter :hide="true" letter="1o"></h1Letter>
      <h1Letter :hide="true" letter="1n"></h1Letter>
      <h1Letter :hide="true" letter="1e"></h1Letter>
    </div>-->
    <div style="width: 100%; font-size: 80px">
      <h1 class="title" style="display: flex; justify-content: space-between">
        <span>192015145</span> <span>stone</span>
      </h1>
    </div>
    <div style="width: 100%">
      <p style="margin-top : 0px">For portoflio send an email to:</p>
      <SLink
        :id="index"
        :key="link.link"
        :link="link.link"
        :name="link.name"
        :skip="link.skip"
        :image="link.image"
        v-for="(link, index) in links"
      />
    </div>
  </div>
</template>
<script>
import SLink from "@/components/Link";
export default {
  components: {
    SLink,
  },
  data() {
    return {
      links: [
      {
          
        },
        {
          image:
            "/mail.png",
          name : "w@192015145.com",
          link: "mailto:w@192015145.com",
        },
        {
         skip: true
        },
        {
          skip: true
        },

        {
          skip: true
        },
       
      ],
    };
  },
};
</script>

<style lang="scss">
.title {
  font-size: min(10vw, 15px);
  margin: 0px;
  font-weight: 100;
}
h1 {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 24px;
  font-style: normal;
  font-variant: normal;
  font-weight: 700;
  line-height: 26.4px;
}
h3 {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 14px;
  font-style: normal;
  font-variant: normal;
  font-weight: 700;
  line-height: 15.4px;
}
p,
a {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 14px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 20px;
}
blockquote {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 21px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 30px;
}
pre {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 13px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 18.5714px;
}
body {
  color: white;
  font-family: sans-serif;
  background-color: black;
}

.logo {
  width: 200px;
  margin-bottom: 20px;
}

.explain_grid {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(5, 1fr);
}
.container {
  height: 100dvh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  margin: auto;
}
</style>
